module.exports = __webpack_public_path__ + "static/img/logo.76bc3441.svg";